import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { IconButton, Tooltip, withStyles, Typography, FormControlLabel, FormGroup, Checkbox, Dialog, Button, Paper, Fab } from '@material-ui/core';
import { Delete, Refresh, CloudUpload, Add } from '@material-ui/icons';
import { DropzoneArea } from 'material-ui-dropzone';
import { downloadFileFromBlob } from '../../sc-utilities/download.utils'
import * as actions from './store/controlMachineActions';
import * as action from '../../sc-core/Auth/store/authActions';
import { BackButton, hasAtLeastOnePermission, hasPermission, localization, getDimensionsOfPagination, formatDate, capitalize } from '../../sc-utilities';
import { connect } from 'react-redux';
import RemoveControlMachinesModal from './RemoveControlMachinesModal';
import { MuiTableRows } from '../../../themes';
import Toolbar from '../../sc-utilities/Toolbar';
import ControlMachineForm from './ControlMachineForm';
import * as Yup from "yup";
import ExportLicensesForm from './ExportLicensesForm';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    typography: {
        marginTop: '8%'
    },
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(1),
        paddingRight: theme.spacing(1),
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    title: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        marginTop: '7px'
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        marginTop: "10px"
    },
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const ControlMachinesList = props => {
    const {
        permissions,
        classes,
        translations,
        fetchControlMachinesCount,
        bulkDeleteControlMachines,
        saveColumnsFilter,
        activeCustomerID,
        tableColumns,
        controlMachines,
        fetchControlMachines,
        controlMachineDetailsInfo,
        setControlMachineDetailsInfo,
        onEditControlMachine,
        tableRef,
        redirectHandler,
        exportLicenses
    } = props;
    const [deleteModalState, setDeleteModalState] = useState({ open: false, controlMachineIDs: [] });
    const [checkboxState, setCheckboxState] = useState(false);
    const [importModalState, setImportModalState] = useState(false);
    const [exportLicenseModalState, setExportLicenseModalState] = useState(false);
    const selectionPermissions = hasAtLeastOnePermission(permissions, ['control_machine_delete']);
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '', buttonDisabled: true, open: false });

    const fetching = controlMachines.fetching;

    const numberToTake = hasPermission(permissions, 'show_only_not_assigned') ? 325 : 292;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: selectionPermissions,
            search: false,
            minBodyHeight: window.innerHeight - numberToTake < 300 ? 300 : window.innerHeight - numberToTake,
            maxBodyHeight: window.innerHeight - numberToTake,
            pageSizeOptions: rowsPageSizeInit,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const handleCloseSafe = () => {
        setDeleteModalState({ open: false, controlMachineIDs: [] });
    };

    const handleCloseDanger = async () => {
        await bulkDeleteControlMachines({ ControlMachineIDs: deleteModalState.controlMachineIDs, ActiveCustomerID: activeCustomerID })
        handleCloseSafe();
        tableRef.current && tableRef.current.onQueryChange()
    };

    const handleBulkDelete = controlMachineIDs => {
        setDeleteModalState({ ...deleteModalState, open: true, controlMachineIDs: controlMachineIDs });
    };

    const handleImportModal = () => {
        setImportModalState(!importModalState);
    };

    const handleLicenseExport = () => {
        setExportLicenseModalState(!exportLicenseModalState);
    }

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    };

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ ...fileToSend, fileToSend: {}, fileName: '', buttonDisabled: true });
            return
        }
        setFileToSend({ ...fileToSend, fileToSend: file, fileName: file.name, buttonDisabled: false });
    };
    const handleSubmit = async event => {
        event.preventDefault();
        if (!fileToSend.fileName || !fileToSend.fileName.includes('.json')) {
            return props.sendMessage(translations['choose_json_file'] || 'Please choose a JSON file', 'warning')
        }
        setFileToSend({ ...fileToSend, buttonDisabled: true });
        const data = new FormData();
        data.append('File', fileToSend.fileToSend);
        data.append('ActiveCustomerID', activeCustomerID);
        let token = localStorage.getItem('SESSION');
        data.append('Token', token);
        let res = await props.importProducts(data);
        if (res) {
            setImportModalState(false);
        }
    };
    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        q['NotAssignedOnly'] = checkboxState;
        query['extendForWEBUI'] = true;
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        let count = await fetchControlMachinesCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchControlMachines(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }


    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden;
            return objColumns;
        })
        objToSendColumn[`ControlMachines`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    };

    const handleCheckboxChange = () => {
        setCheckboxState(!checkboxState);
        tableRef.current && tableRef.current.onQueryChange();
    }

    const handleNameChange = (values) => {
        onEditControlMachine({
            Name: values.Name,
            ControlMachineID: controlMachineDetailsInfo.ControlMachineID
        })
        tableRef.current && tableRef.current.onQueryChange();
        setControlMachineDetailsInfo({ open: false })
    };

    const handleExportLicenses = async (values) => {
        let params = {
            ActiveCustomerID: activeCustomerID,
            LicenseVaultID: values.LicenseVaultID,
            NumberOfLicenses: values.NumberOfLicenses,
            Unit: values.Unit,
        };
        const result = await exportLicenses(params);
        downloadFileFromBlob(result?.result?.data?.lv, 'lv');
    };

    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography> {translations["control_machines"] || 'Control machines'}</Typography>
                {hasPermission(permissions, 'control_machine_create') ? <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="Add"
                    className={classes.fab}
                    style={{ borderRadius: '1px' }}
                    onClick={() => redirectHandler(`/settings/create-offline-command`)}
                >
                    <Add size="small" />
                    {translations["create_new"] || "Create new"}
                </Fab> : null}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
                <Tooltip title={translations["import_command_data"] || "Import Offline Command data"}>
                    <IconButton aria-label={translations["import_command_data"] || "Import Offline Command data"} component="div" disabled={fetching} onClick={handleImportModal}>
                        <CloudUpload />
                    </IconButton>
                </Tooltip>
                <Tooltip title={translations["export_licenses"] || "Export Licenses for Offline use"}>
                    <IconButton aria-label={translations["export_licenses"] || "Export Licenses for Offline use"} component="div" disabled={fetching} onClick={handleLicenseExport}>
                        <CloudUpload />
                    </IconButton>
                </Tooltip>
            </div>
            {
                hasPermission(permissions, 'access_all_control_machines') ?
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id="checkbox_locked"
                                    name={"show_only_not_assigned"}
                                    checked={checkboxState}
                                    onChange={handleCheckboxChange}
                                    color={'primary'}
                                />
                            }
                            label={translations["show_only_not_assigned"] || "Show only not assigned"}
                        />
                    </FormGroup>
                    : null
            }
            {controlMachineDetailsInfo.open ?
                <Dialog
                    id="control-machine-details"
                    open={controlMachineDetailsInfo.open}
                    disableBackdropClick={true}
                    disableEscapeKeyDown={false}
                    disableEnforceFocus={false}
                    fullWidth={true}
                    onClose={() => setControlMachineDetailsInfo({ open: false })}
                >
                    <ControlMachineForm
                        formSettings={{
                            ValidationForm: {
                                Name: Yup.string().required("Required")
                            },
                            FormTitle: translations["control_machine_details"] || "Control machine details",
                            ButtonSubmit: {
                                Title: translations["save"] || "SAVE"
                            }
                        }}
                        initialValues={{
                            HardwareID: controlMachineDetailsInfo && controlMachineDetailsInfo.HardwareID ? controlMachineDetailsInfo.HardwareID : translations['short_not_assigned'] || 'n/a',
                            Name: controlMachineDetailsInfo && controlMachineDetailsInfo.Name ? controlMachineDetailsInfo.Name : '',
                            RemoteID: controlMachineDetailsInfo && controlMachineDetailsInfo.RemoteID ? controlMachineDetailsInfo.RemoteID : '',
                            RemotePassword: controlMachineDetailsInfo && controlMachineDetailsInfo.RemotePassword ? controlMachineDetailsInfo.RemotePassword : '',
                            LicenseName: controlMachineDetailsInfo.License?.Name || translations['short_not_assigned'] || 'n/a',
                            ExpiresAt: formatDate(controlMachineDetailsInfo.License?.ExpiresAt) || translations['short_not_assigned'] || 'n/a',
                            LicenseStatus: controlMachineDetailsInfo.License && controlMachineDetailsInfo.License.Status ? controlMachineDetailsInfo.License.Status === 'active' ? translations["active"] || "Active" : translations["inactive"] || "Inactive" : translations['short_not_assigned'] || 'n/a'
                        }}
                        translations={translations}
                        handleSubmit={handleNameChange}
                    />
                </Dialog>
                : null}
            {
                importModalState ?

                    <Dialog
                        open={importModalState}
                        disableBackdropClick={false}
                        disableEscapeKeyDown={false}
                        disableEnforceFocus={false}
                        fullWidth={true}
                        onClose={() => setImportModalState(false)}
                    >
                        <Paper className={classes.root} >
                            <Typography>
                                {translations['supported_format'] || 'Supported format'}{' .JSON '}.<br />
                            </Typography>
                            <form >
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={5368709120}
                                    getFileRemovedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                        ) : `File ${fileName} removed.`
                
                                        return text;
                                    }}
                                    getFileAddedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                        ) : `File ${fileName} successfully added.`
                
                                        return text;
                                    }}
                                    getFileLimitExceedMessage={(filesLimit) => {
                                        const text = translations ? (
                                            capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                        ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
                
                                        return text;
                                    }}
                                    getDropRejectMessage={(rejectedFile) => {
                                        const text = translations ? (
                                            capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                        ) : `File was rejected.`
                
                                        return text;
                                    }}
                                    dropzoneText={`${translations['drag_and_drop_an'] || 'Drag and drop an'} .json ${translations['file_here'] || 'file here or click'}`}
                                    onChange={handleUpload}
                                    acceptedFiles={['.json']}
                                />
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    type="submit"
                                    onClick={handleSubmit}
                                    fullWidth={true}
                                    disabled={fileToSend.buttonDisabled}
                                >
                                    {translations['import'] || "Import"}
                                </Button>
                            </form>
                        </Paper>
                    </Dialog> : null
            }
            {
                exportLicenseModalState ?

                    <Dialog
                        open={exportLicenseModalState}
                        disableBackdropClick={false}
                        disableEscapeKeyDown={false}
                        disableEnforceFocus={false}
                        fullWidth={true}
                        onClose={() => setExportLicenseModalState(false)}
                    >
                        <ExportLicensesForm
                            formSettings={{
                                ValidationForm: {
                                    LicenseVaultID: Yup.string().required('Required'),
                                    NumberOfLicenses: Yup.number().required('Required'),
                                    Unit: Yup.string().required('Required')
                                },
                                FormTitle: translations["export_licenses"] || "Export Licenses",
                                ButtonSubmit: {
                                    Title: translations["save"] || "SAVE"
                                }
                            }}
                            initialValues={{
                                LicenseVaultID: null,
                                NumberOfLicenses: 0,
                                Unit: 'work'
                            }}
                            translations={translations}
                            handleSubmit={handleExportLicenses}
                        />
                    </Dialog> : null
            }
        </div>
    };

    const tableActions = [
        {
            tooltip: `${translations["remove_all_selected"] || "Remove all selected"} ${translations["control_machines"] || "Control machines"}`,
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(controlMachine => controlMachine.ControlMachineID))
        }
    ];

    return <>
        <MaterialTable
            components={{
                Toolbar: props => (
                    <Toolbar
                        data={props}
                        actions={tableActions}
                        selectedRows={props.selectedRows}
                        translations={translations}
                    />
                )
            }}
            localization={localization(translations)}
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            onChangeRowsPerPage={(size) => pageSize = size}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {deleteModalState.open ?
            <RemoveControlMachinesModal handleCloseDanger={handleCloseDanger} handleCloseSafe={handleCloseSafe} translations={translations} deleteModalState={deleteModalState} />
            : null}
    </>
}

const mapDispatchToProps = dispatch => {
    return {
        fetchControlMachinesCount: filter => dispatch(actions.fetchControlMachinesCount(filter)),
        fetchControlMachines: filter => dispatch(actions.fetchControlMachines(filter)),
        bulkDeleteControlMachines: queryParams => dispatch(actions.bulkDeleteControlMachines(queryParams)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onEditControlMachine: data => dispatch(actions.editControlMachine(data)),
        importProducts: data => dispatch(actions.importProducts(data)),
        exportLicenses: data => dispatch(actions.exportOfflineLicenses(data))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        controlMachines: state.statistic.controlMachines
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ControlMachinesList));